module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_7005.949471a6.png";